import Cheese from './cheese.webp';
import Credits from './Credits.webp';
import Dungeon from './dungeon.webp';
import Dungeon1 from './dungeon1.webp';
import Enter from './enter.webp';
import Menu from './menu.webp';
import Overview from './overview.webp';
import Shop from './shop.webp';
import Storage from './storage.webp';

export default {
    Cheese,
    Credits,
    Dungeon,
    Dungeon1,
    Enter,
    Menu,
    Overview,
    Shop,
    Storage
}